import { getHelpCenterAnalyticsData } from './help-center-analytics-data';

export { getHelpCenterAnalyticsData };
